import { generateEventId, urlify } from '../../utils/string';

const viewAnalytics = (price, product, setup, fromList = {}) => {
	if (typeof window.dataLayer === 'undefined') window.dataLayer = [];
	const uniqueEventID = generateEventId();

	window.dataLayer.push({ ecommerce: null });
	window.dataLayer.push({
		event: 'ViewContent',
		event_id: uniqueEventID,
		values: {
			value: price.priceAsNumber,
			currency: setup.countries[setup.country].currency,
			content_name: product.name,
			content_type: 'product',
			content_ids: [`1/${setup.country.toLowerCase()}-p${product.silkProduct}-v${product.silkVariant}-s`],
		},
	});

	window.dataLayer.push({ ecommerce: null });
	window.dataLayer.push({
		event: 'ViewContentGA',
		ecommerce: {
			detail: {
				actionField: { list: fromList[`p${product.silkProduct}-v${product.silkVariant}`] || '' },
				products: [{
					name: product.name,
					id: product.silkProduct,
					sku: product.productSku,
					price: price.priceAsNumber,
					brand: product.brandName,
					category: product.canonicalUri.slice(0, product.canonicalUri.lastIndexOf('/')),
					variant: product.variantName,
				}],
			},
		},
	});

	window.dataLayer.push({ ecommerce: null });
	const itemCategory = product.canonicalUri.split('/').slice(0, -1).reduce((acc, category, j) => ({ ...acc, [`item_category${j > 0 ? j + 1 : ''}`]: category }), {});

	window.dataLayer.push({
		event: 'view_item',
		ecommerce: {
			'x-fb-event_id': uniqueEventID,
			currency: setup.countries[setup.country].currency,
			items: [{
				item_name: product.name,
				item_id: product.silkProduct,
				price: price.priceAsNumber,
				currency: setup.countries[setup.country].currency,
				item_brand: product.brandName,
				...itemCategory,
				item_list_id: urlify(fromList[`p${product.silkProduct}-v${product.silkVariant}`] || ''),
				item_list_name: fromList[`p${product.silkProduct}-v${product.silkVariant}`] || '',
				quantity: '1',
			}],
		},
	});
};

export default viewAnalytics;
